import { useState } from 'react';
import { MAX_NAME_LENGTH } from '@bm/shared';
import { de } from '@/i18n/de';
import { AppShell } from '@/components/AppShell';
import { Button } from '@/components/Button';

interface NameEntryScreenProps {
  mode: 'create' | 'join';
  onSubmit: (name: string) => void;
  onBack: () => void;
}

export function NameEntryScreen({ mode, onSubmit, onBack }: NameEntryScreenProps) {
  const [name, setName] = useState('');
  const trimmed = name.trim();

  return (
    <AppShell>
      <form
        className="mx-auto flex h-full max-w-sm flex-col justify-center gap-6"
        onSubmit={(event) => {
          event.preventDefault();
          if (trimmed.length > 0) onSubmit(trimmed);
        }}
      >
        <button
          type="button"
          onClick={onBack}
          className="self-start text-sm text-fg-muted hover:text-fg"
        >
          {de.common.back}
        </button>

        <h1 className="font-display text-2xl font-bold">{de.nameEntry.title}</h1>

        <input
          autoFocus
          value={name}
          onChange={(event) => setName(event.target.value)}
          maxLength={MAX_NAME_LENGTH}
          placeholder={de.nameEntry.placeholder}
          enterKeyHint="go"
          className="min-h-14 rounded-2xl border border-surface-border bg-surface px-4 text-lg text-fg outline-none placeholder:text-fg-faint focus:border-accent"
          style={{ fontSize: '16px' }}
        />

        <Button type="submit" disabled={trimmed.length === 0}>
          {mode === 'create' ? de.nameEntry.create : de.nameEntry.join}
        </Button>
      </form>
    </AppShell>
  );
}
